import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

import { IconTypes } from 'src/types';

export type CaretProps = SvgIconProps;
export const Caret: FC<CaretProps> = props => (
  <SvgIcon aria-label={IconTypes.CARET} {...props}>
    <g>
      <path
        clipRule="evenodd"
        d="M5.87868 0.87868C7.05025 -0.292893 8.94975 -0.292893 10.1213 0.87868L19.1213 9.87868C20.2929 11.0503 20.2929 12.9497 19.1213 14.1213L10.1213 23.1213C8.94975 24.2929 7.05025 24.2929 5.87868 23.1213C4.70711 21.9497 4.70711 20.0503 5.87868 18.8787L12.7574 12L5.87868 5.12132C4.70711 3.94975 4.70711 2.05025 5.87868 0.87868Z"
        fillRule="evenodd"
      />
    </g>
  </SvgIcon>
);
